import { Link } from 'react-router-dom'

interface CustomNavLinkProps {
  to: string
  currentPath: string
  children: React.ReactNode
  onClick?: () => void
}

export const CustomNavLink = ({ to, currentPath, children, onClick }: CustomNavLinkProps) => (
  <Link
    to={to}
    onClick={onClick}
    className={`px-3 py-2 text-sm font-medium cursor-pointer ${
      currentPath.includes(to) ? 'border-b-4 border-indigo-200 hover:bg-indigo-100' : ''
    }`}
  >
    {children}
  </Link>
)
